import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { App as AntdApp, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { AuthProvider } from './auth/AuthProvider';
import './styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

// 使用数据路由（createBrowserRouter）以便内容表单可以使用 useBlocker 做未保存离开提醒
// basename 取构建时的 base（默认 /admin），使后台可挂在主域子路径下访问
const routerBasename = (import.meta.env.BASE_URL || '/admin/').replace(/\/$/, '') || '/';
const router = createBrowserRouter([{ path: '*', element: <App /> }], {
  basename: routerBasename,
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('缺少 #root 挂载节点');
}

createRoot(rootElement).render(
  <StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          // 品牌 Token 来源：04-UI设计规范 第 2 节
          colorPrimary: '#7A2CC7',
          colorTextBase: '#17151C',
          colorBgLayout: '#F7F6FA',
          borderRadius: 8,
        },
      }}
    >
      <AntdApp>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </QueryClientProvider>
      </AntdApp>
    </ConfigProvider>
  </StrictMode>,
);
